// extracted by mini-css-extract-plugin
export var avatarContainer = "_4q-1";
export var largeAvatarContainer = "_4q-2";
export var smallAvatarContainer = "_4q-0";